import React from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import InputWithIcon from "../../components/FormFields/InputWithIcon";
import CustomButton from "../../components/CustomButton";
import DatePicker from "../../components/FormFields/DatePicker";
import TextArea from "../../components/FormFields/TextArea";
import { Form, Formik } from "formik";
import { imprestValidation } from "../../utils/validations/imprest";
import moment from "moment";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { sendToDBDateFormat } from "../../utils/helpers";

const RequestImprestAmount = () => {
  const { apiCall } = useApi();
  const navigate = useNavigate();
  const onSubmitRequest = (values) => {
    const dataToSend = {
      dataModalAttributeSet: [
        {
          attributeValue: values.description,
          metadataTechnicalName: "description",
        },
        { attributeValue: values.amount, metadataTechnicalName: "amount" },
        {
          attributeValue: moment(values.date).format(sendToDBDateFormat),
          metadataTechnicalName: "date",
        },
      ],
      metadataSchemaId: 6,
    };

    apiCall({
      url: apiUrls.dmsService.createRecord,
      dataToSend,
      method: "post",
      onSuccess: () => {
        toast.success("Request has been submitted successfully");
        navigate(-1);
      },
    });
  };
  const onChangeDate = (date, setFieldValue) => {
    setFieldValue("date", date);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{ date: new Date(), amount: "", description: "" }}
      validationSchema={imprestValidation}
      onSubmit={onSubmitRequest}
    >
      {({ errors, touched, values, setFieldValue }) => {
        return (
          <Form>
            <div className="dashboard-container">
              <ToolbarHeader
                title="Request Imprest Amount"
                showBack
                containerClassName="mt-14"
              />
              <div className="bg-[var(--whiteColor)] rounded-[1rem] mt-6 p-8 flex flex-col gap-y-4">
                <DatePicker
                  title="Date"
                  datePickerTextClassName="text-[var(--textGray2)]"
                  startDate={values?.date}
                  onChange={(date) => onChangeDate(date, setFieldValue)}
                  error={touched.date && errors?.date}
                  minDate={new Date()}
                  disabled
                />

                <div className="flex flex-col">
                  <InputWithIcon
                    title="Required Amount (₹)"
                    containerClassName="!bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)] !h-[5rem]"
                    onChange={(e) => {
                      setFieldValue("amount", e);
                    }}
                    value={values?.amount}
                    error={errors?.amount}
                    type="number"
                  />
                </div>

                <TextArea
                  title="Description"
                  containerClassName="!bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)] !w-[100%]"
                  onChange={(e) => {
                    setFieldValue("description", e);
                  }}
                  value={values?.description}
                  error={touched.description && errors?.description}
                />
              </div>
              <div className="flex justify-between mt-8 gap-x-10">
                <CustomButton
                  title="Discard"
                  wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8 w-[50%]"
                  onClick={() => {
                    navigate(-1)
                  }}
                />
                <CustomButton
                  title="Send Request"
                  wrapperClassName="!px-8 w-[50%]"
                  type="submit"
                />
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default RequestImprestAmount;
